import React, { FC, Dispatch, SetStateAction } from 'react'
import { Modal, Button, Input } from 'antd'
import ReactPlayer from 'react-player'
// import Lottie from 'react-lottie'

import { Links, LottieJSON } from '../../utils/links'
import { useTypedSelector } from '../../hooks/useTypedSelector'

type InteractiveModalProps = {
    showModal: boolean
    handleAgreeAnimation(playStoreInput: boolean): void
    handleDisagreeAnimation(): void
    handleCloseInteractiveModal(): void
    handleDownloadVideo(): void
    playStoreInput: boolean
    playStoreId: string
    setPlayStoreId: Dispatch<SetStateAction<string>>
    playStoreIdValidate: 'id_invalid' | 'id_empty' | null
    firmLogo: string
    code: string
}

const InteractiveModal: FC<InteractiveModalProps> = ({
    handleCloseInteractiveModal,
    // handleDisagreeAnimation,
    handleDownloadVideo,
    showModal,
    handleAgreeAnimation,
    playStoreInput,
    playStoreId,
    setPlayStoreId,
    playStoreIdValidate,
    firmLogo,
    code,
}) => {
    const {
        user: {
            user: { logo },
        },
    } = useTypedSelector((state) => state)

    return (
        <>
            <Modal
                centered={true}
                visible={showModal}
                destroyOnClose={true}
                cancelButtonProps={{ style: { display: 'none' } }}
                closable={true}
                mask={false}
                title={null}
                footer={null}
                className="interactive-modal"
                width={570}
                getContainer={() => document.getElementById('landing-page-layout')!}
                onOk={handleCloseInteractiveModal}
                onCancel={handleCloseInteractiveModal}
            >
                <div className="interactive-modal-inner">
                    <div className="interactive-modal-player">
                        <ReactPlayer
                            width={'100%'}
                            height={'100%'}
                            loop={true}
                            playing={true}
                            controls={false}
                            muted={true}
                            url={
                                logo && logo !== 'img/avatar/googler.svg'
                                    ? `https://oss.uppmkt.com/202205/SOA_web/app/${code.toUpperCase()}.mp4`
                                    : `https://oss.uppmkt.com/202205/SOA_web/app/Google.mp4`
                            }
                        />
                        {/* <Lottie
                            isClickToPauseDisabled={true}
                            options={{
                                loop: true,
                                autoplay: true,
                                path: LottieJSON.Preview,
                                renderer: 'svg',
                            }}
                        ></Lottie> */}
                    </div>
                    <div className="interactive-modal-desc">
                        <div>
                            {playStoreInput
                                ? '请重新提交正确 App 网址，生成您的专属纪念视频！'
                                : '开始生成您的专属纪念视频！'}
                        </div>
                        {playStoreInput ? (
                            <div>
                                <span>
                                    很抱歉 ， 由于您在报名时提交的 App 网址失效、有误或填写公司网址 ，
                                    您的专属纪念视频将使用 Google Logo 进行生成。若希望使用您的 App 图标进行制作 ，
                                    请重新提供您的正确 Play 商店 App 网址。
                                </span>
                            </div>
                        ) : (
                            <div id="interactive-modal-desc-not-url-input">
                                我们将使用您报名时提供的 Play 商店 App 地址的应用图标进行制作
                            </div>
                        )}
                    </div>
                    {playStoreInput ? (
                        <div className="interactive-modal-frame-img">
                            <img src={Links.FRAME} alt="" />
                        </div>
                    ) : null}

                    <div className={playStoreInput ? 'interactive-modal-btn-gp url-input' : 'interactive-modal-btn-gp'}>
                        {playStoreInput ? (
                            <>
                                <div className="interactive-modal-play-store-id-hint">
                                    {playStoreIdValidate ? (
                                        playStoreIdValidate === 'id_invalid' ? (
                                            <span>App 网址格式不符</span>
                                        ) : (
                                            <span>App 网址不能为空</span>
                                        )
                                    ) : null}
                                </div>

                                <div className="interactive-modal-play-store-id-input">
                                    <Input
                                        placeholder="https://play.google.com/store/apps/details?id= App ID"
                                        value={playStoreId}
                                        onChange={(e) => setPlayStoreId(e.target.value)}
                                    />
                                    <Button
                                        className="interactive-modal-url-submit"
                                        onClick={() => handleAgreeAnimation(playStoreInput)}
                                    >
                                        确认提交
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <Button
                                className="interactive-modal-agree"
                                // onClick={() => handleAgreeAnimation(playStoreInput)}
                                onClick={handleDownloadVideo}
                            >
                                {/* 即刻开始 */}
                                下载您的专属纪念视频
                            </Button>
                        )}

                        {/* <Button className="interactive-modal-disagree" onClick={handleDisagreeAnimation}>
                            <p>没关系，我就看看，用 Google Logo 就好</p>
                        </Button> */}
                    </div>
                    {/* {playStoreInput ? null : (
                        <div className="interactive-modal-info">
                            <p>
                                1.若您填写一个以上的 App 网址，系统将使用第一个填写的 App 网址应用图标制作您的专属火箭！
                            </p>
                            <p> 2.若您只填寫您的官方网站，系统将以 Google logo 作为代表来制作您的专属火箭！</p>
                        </div>
                    )} */}
                </div>
            </Modal>
        </>
    )
}

export default InteractiveModal
